import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICObjective } from "../models/entities/icobjective";
import { ICObjectiveFilter } from "../models/filters/icobjective.filter";
import { ICObjectiveApi } from "../models/apis/icobjective.api";
import { BaseDataService } from "./shared/base.data.service";

@Injectable()
export class ICObjectiveService extends BaseDataService<
  ICObjective,
  ICObjectiveFilter,
  ICObjectiveApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICObjective);
    this.EndPoint = "icobjective";
  }
}
